var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 118,
    viewBox: "0 0 95 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.464 4.72512C46.5052 4.23662 47.22 4.23661 47.2612 4.72512L52.7563 69.8681C52.8454 70.9242 53.1203 71.9563 53.5684 72.9168L72.3326 113.135C72.5401 113.579 71.9188 113.935 71.6406 113.531L50.1579 82.3094C48.5683 79.9993 45.1569 79.9993 43.5673 82.3094L22.0845 113.531C21.8063 113.935 21.185 113.579 21.3925 113.135L40.1567 72.9169C40.6049 71.9563 40.8798 70.9242 40.9689 69.8681L46.464 4.72512Z",
    fill: "url(#paint0_linear_1_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8688 69.9222L42.2726 55.4169C42.2933 55.203 42.5909 55.1679 42.6608 55.3712L52.9549 85.3176C53.0288 85.5327 52.7436 85.6847 52.6063 85.5034L40.9085 70.0623C40.8781 70.0222 40.864 69.9722 40.8688 69.9222Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.31267,
    height: 1.1386,
    transform: "matrix(-0.707142 0.707071 -0.707142 -0.707071 8.57029 100.432)",
    fill: "url(#paint1_linear_1_16)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.31267,
    height: 1.1386,
    transform: "matrix(0.707159 0.707055 0.707159 -0.707055 86.3672 100.432)",
    fill: "url(#paint2_linear_1_16)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92369,
    height: 1.1386,
    transform: "matrix(0.707142 -0.707071 -0.707142 -0.707071 2.27146 106.729)",
    fill: "url(#paint3_linear_1_16)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.477485,
    height: 1.1386,
    transform: "matrix(0.707142 -0.707071 -0.707142 -0.707071 0.804665 108.196)",
    fill: "url(#paint4_linear_1_16)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92369,
    height: 1.1386,
    transform: "matrix(-0.707159 -0.707055 0.707159 -0.707055 92.666 106.729)",
    fill: "url(#paint5_linear_1_16)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.28144,
    height: 1.1386,
    transform: "matrix(-0.707159 -0.707055 0.707159 -0.707055 93.8437 107.906)",
    fill: "url(#paint6_linear_1_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8667 97.4903L64.7964 78.4228C61.5951 75.222 59.5139 71.0724 58.8629 66.5924L51.3652 14.9985",
    stroke: "url(#paint7_linear_1_16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3617 97.4903L29.4321 78.4228C32.6333 75.222 34.7146 71.0724 35.3656 66.5924L42.8633 14.9985",
    stroke: "url(#paint8_linear_1_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.8633 49.4948L35.8633 26.9971",
    stroke: "url(#paint9_linear_1_16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.3652 66.9933L62.3652 48.9951",
    stroke: "url(#paint10_linear_1_16)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M59.3652 36.4971L58.3652 29.4971",
    stroke: "url(#paint11_linear_1_16)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.3633 7L40.8633 4",
    stroke: "url(#paint12_linear_1_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16",
    x1: 88.6589,
    y1: 162.967,
    x2: 3.14253,
    y2: 38.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_16",
    x1: 1.65634,
    y1: 0,
    x2: 1.65634,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_16",
    x1: 1.65634,
    y1: 0,
    x2: 1.65634,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_16",
    x1: 0.961844,
    y1: 0,
    x2: 0.961844,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_16",
    x1: 0.238742,
    y1: 0,
    x2: 0.238742,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_16",
    x1: 0.961844,
    y1: 0,
    x2: 0.961844,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_16",
    x1: 0.14072,
    y1: 0,
    x2: 0.14072,
    y2: 1.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_16",
    x1: 72.6162,
    y1: 14.9985,
    x2: 72.6162,
    y2: 97.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_16",
    x1: 29.3626,
    y1: 16.9983,
    x2: 21.6145,
    y2: 97.4905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_16",
    x1: 24.3633,
    y1: 16.9981,
    x2: 16.6148,
    y2: 97.4902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_16",
    x1: 72.8652,
    y1: 34.4966,
    x2: 80.6137,
    y2: 114.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_16",
    x1: 68.8652,
    y1: 13.4971,
    x2: 76.6152,
    y2: 93.9971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_16",
    x1: 31.8633,
    y1: -17,
    x2: 24.1133,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSvg);
export default __webpack_public_path__ + "static/media/rocket-svg.c1b22b7598f7d0fc6f7e66a5465f8ebc.svg";
export { ForwardRef as ReactComponent };